import { CloseIcon } from 'components/icons/CloseIcon';
import { cn } from 'lib/utils';
import { ToastContainerProps } from 'react-toastify';

import { useLanguage } from '../../context/language.context';

interface ToastProps extends ToastContainerProps {
  title: string;
  description?: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  closeToast?: () => void;
}

export const Toast: React.FC<ToastProps> = ({
  title,
  description,
  type = 'success',
  closeToast,
}) => {
  const { direction } = useLanguage();

  return (
    <div
      className="relative flex bg-[#1C1C1E] h-full w-full rounded-lg overflow-hidden"
      dir={direction}
      style={{ fontFamily: direction === 'rtl' ? 'TheSansArab, sans-serif' : 'Inter, sans-serif' }}
    >
      <div
        className={cn(
          'absolute top-0 w-1 h-full',
          direction === 'rtl' ? 'right-0' : 'left-0',
          type === 'success' && 'bg-[#33FFB4]',
          type === 'error' && 'bg-red-400',
          type === 'warning' && 'bg-primary-yellow-1',
          type === 'info' && 'bg-primary-blue-1',
        )}
      />
      <div className="w-full py-4 px-5">
        <div className="flex justify-between items-center gap-4">
          <p className="font-semibold truncate text-m leading-6 text-primary-white-1">{title}</p>
          <span onClick={closeToast} className="cursor-pointer">
            <CloseIcon width={16} height={16} fill="#656463" />
          </span>
        </div>
        <p className="text-sm mt-1 text-gray-600 text-wrap">{description}</p>
      </div>
    </div>
  );
};
